import { render } from "./TournamentCategories.vue?vue&type=template&id=05e37e07"
import script from "./TournamentCategories.vue?vue&type=script&lang=js"
export * from "./TournamentCategories.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__